import { EditorModule } from 'primeng/editor';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreRoutingModule } from './core-routing.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslatePipe
} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TableModule } from 'primeng/table';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FileUploadModule } from 'primeng/fileupload';
import { CalendarModule } from 'primeng/calendar';
import { TreeTableModule } from 'primeng/treetable';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { PaginatorModule } from 'primeng/paginator';
import { TreeModule } from 'primeng/tree';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
//import { AgmCoreModule } from '@agm/core';

import { ChartModule } from 'angular-highcharts';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AppLauncherComponent, FrameworkModule as ArcoCoreModule } from 'itcores-fw';
import { DropdownModule } from 'primeng/dropdown';
import { AppLanguages } from './models/app-languages';
import { AppUrls } from './helpers/app-urls';
import { NotAuthorizedPageComponent } from './components/not-authorized-page/not-authorized-page.component';
import { environment } from '@environments/environment';
import { LeftSideMenuComponent } from './layouts/left-side-menu/left-side-menu.component';
import { HeaderComponent } from './layouts/header/header.component';
import { ColorSettingComponent } from './components/color-setting/color-setting.component';
import { RootLayoutComponent } from './layouts/root-layout/root-layout.component';

// Custom translation loader that handles base href properly
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    NotAuthorizedPageComponent,
    LeftSideMenuComponent,
    HeaderComponent,
    ColorSettingComponent,
    RootLayoutComponent
  ],
  imports: [
    ArcoCoreModule.forRoot({
      apiEndpoint: environment.businessSectorApiUrl,
      businessApiEndpoint: environment.businessSectorApiUrl,
      financeApiEndpoint: environment.financialSectorApiUrl,
      autoCompleteDelay: environment.autoCompleteDelay,
      arcoApiUrl: environment.arcoApiUrl,
      maxDocumentSize: environment.maxDocumentSize,
      reportingApiUrl: environment.reportingApiUrl,
      reportingConnectionStringName: 'BusinessSectorContext',
      appLanguages: AppLanguages,
      appUrls: AppUrls,
      tokenKey: environment.tokenKey
    }),
    CommonModule,
    CoreRoutingModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient]
      }
    }),
    // AgmCoreModule.forRoot({
    //   apiKey: environment.mapsApiKey
    // }),
    TableModule,
    FormsModule,
    PaginatorModule,
    TooltipModule,
    AppLauncherComponent,
    RadioButtonModule,

  ],
  exports: [
    ArcoCoreModule,
    TranslateModule,
    TranslatePipe,
    TableModule,
    CalendarModule,
    TooltipModule,
    RadioButtonModule,
    FileUploadModule,
    AutoCompleteModule,
    // AgmCoreModule,
    // AgmCoreModule,
    TreeTableModule,
    CheckboxModule,
    EditorModule,
    ChartModule,
    MenuModule,
    FormsModule,
    MultiSelectModule,
    NgMultiSelectDropDownModule,
    TreeModule,
    DropdownModule,
    NotAuthorizedPageComponent,
    FormsModule,
    ReactiveFormsModule,
    ColorSettingComponent,
    RootLayoutComponent
  ]
})
export class CoreModule { }
